<template>
    <BreadCrumb PageTitle="Liste des Zones du Besc" />
    <ListeZone/>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import BreadCrumb from "../../components/Common/BreadCrumb.vue";
import ListeZone from "@/components/Zone/ListeZone.vue";

export default defineComponent({
    name: "ListeZonePage",
    components: {
        BreadCrumb,
        ListeZone,
    },
});
</script>